export type MIMEFileObjectType = {
  mimeCode: MIMEFileType;
  acordCode: string;
  extension: FileExtension | '';
};

export enum MIMEFileType {
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  GIF = 'image/gif',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  HTML = 'text/html',
  JPEG = 'image/jpeg',
  MSG = 'application/vnd.ms-outlook',
  OCTET_STREAM = 'application/octet-stream',
  PDF = 'application/pdf',
  PNG = 'image/png',
  TIF = 'image/tiff',
  TXT = 'text/plain',
  XLS = 'application/vnd.ms-excel',
  XLSM = 'application/vnd.ms-excel.sheet.macroEnabled.12',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XML = 'text/xml',
  ZIP = 'application/zip',
}

export enum FileExtension {
  ASPX = 'aspx',
  DOC = 'doc',
  DOCX = 'docx',
  EHD = 'ehd',
  EML = 'eml',
  GIF = 'gif',
  HEIC = 'heic',
  HEIF = 'heif',
  HTM = 'htm',
  HTML = 'html',
  INDEX = 'index',
  JFIF = 'jfif',
  JPEG = 'jpeg',
  JPG = 'jpg',
  MSG = 'msg',
  PDF = 'pdf',
  PNG = 'png',
  TIF = 'tif',
  TIFF = 'tiff',
  TXT = 'txt',
  XLS = 'xls',
  XLSM = 'xlsm',
  XLSX = 'xlsx',
  XML = 'xml',
  ZIP = 'zip',
}

export abstract class MIMEFileTypes {
  private static readonly MIME_TYPES: Array<MIMEFileObjectType> = [
    {
      mimeCode: MIMEFileType.HTML,
      acordCode: '44',
      extension: FileExtension.ASPX,
    },
    {
      mimeCode: MIMEFileType.DOC,
      acordCode: '59',
      extension: FileExtension.DOC,
    },
    {
      mimeCode: MIMEFileType.DOCX,
      acordCode: '60',
      extension: FileExtension.DOCX,
    },
    {
      mimeCode: MIMEFileType.HTML,
      acordCode: '44',
      extension: FileExtension.EHD,
    },
    {
      mimeCode: MIMEFileType.OCTET_STREAM,
      acordCode: '9',
      extension: FileExtension.EML,
    },
    {
      mimeCode: MIMEFileType.GIF,
      acordCode: '4',
      extension: FileExtension.GIF,
    },
    {
      mimeCode: MIMEFileType.HEIC,
      acordCode: '2147483647',
      extension: FileExtension.HEIC,
    },
    {
      mimeCode: MIMEFileType.HEIF,
      acordCode: '2147483647',
      extension: FileExtension.HEIF,
    },
    {
      mimeCode: MIMEFileType.HTML,
      acordCode: '44',
      extension: FileExtension.HTM,
    },
    {
      mimeCode: MIMEFileType.HTML,
      acordCode: '44',
      extension: FileExtension.HTML,
    },
    {
      mimeCode: MIMEFileType.JPEG,
      acordCode: '3',
      extension: FileExtension.JFIF,
    },
    {
      mimeCode: MIMEFileType.JPEG,
      acordCode: '3',
      extension: FileExtension.JPEG,
    },
    {
      mimeCode: MIMEFileType.JPEG,
      acordCode: '3',
      extension: FileExtension.JPG,
    },
    {
      mimeCode: MIMEFileType.MSG,
      acordCode: '2147483647',
      extension: FileExtension.MSG,
    },
    {
      mimeCode: MIMEFileType.OCTET_STREAM,
      acordCode: '9',
      extension: '',
    },
    {
      mimeCode: MIMEFileType.PDF,
      acordCode: '17',
      extension: FileExtension.PDF,
    },
    {
      mimeCode: MIMEFileType.PNG,
      acordCode: '33',
      extension: FileExtension.PNG,
    },
    {
      mimeCode: MIMEFileType.TIF,
      acordCode: '11',
      extension: FileExtension.TIF,
    },
    {
      mimeCode: MIMEFileType.TIF,
      acordCode: '11',
      extension: FileExtension.TIFF,
    },
    {
      mimeCode: MIMEFileType.TXT,
      acordCode: '1',
      extension: FileExtension.TXT,
    },
    {
      mimeCode: MIMEFileType.XLS,
      acordCode: '56',
      extension: FileExtension.XLS,
    },
    {
      mimeCode: MIMEFileType.XLSM,
      acordCode: '56',
      extension: FileExtension.XLSM,
    },
    {
      mimeCode: MIMEFileType.XLSX,
      acordCode: '57',
      extension: FileExtension.XLSX,
    },
    {
      mimeCode: MIMEFileType.XML,
      acordCode: '46',
      extension: FileExtension.XML,
    },
    {
      mimeCode: MIMEFileType.ZIP,
      acordCode: '25',
      extension: FileExtension.ZIP,
    },
  ];

  static findMimeCodeByAcordCode(acordCode: string): MIMEFileType {
    const mIMEFileType: MIMEFileObjectType = this.findByAcordCode(acordCode);
    return mIMEFileType && mIMEFileType.mimeCode;
  }
  static findMimeCodeByExtension(extension: string): MIMEFileType {
    const mIMEFileType: MIMEFileObjectType = this.findByExtension(extension);
    return mIMEFileType && mIMEFileType.mimeCode;
  }
  static findByExtension(extension: string): MIMEFileObjectType {
    extension = `${extension}`.trim().toLowerCase();
    return MIMEFileTypes.MIME_TYPES.find((value: MIMEFileObjectType) => {
      return value.extension === extension;
    }) as MIMEFileObjectType;
  }
  static findByAcordCode(acordCode: string): MIMEFileObjectType {
    return MIMEFileTypes.MIME_TYPES.find((value: MIMEFileObjectType) => {
      return value.acordCode === acordCode;
    }) as MIMEFileObjectType;
  }
}
